import { render, staticRenderFns } from "./registeraddresses.vue?vue&type=template&id=7d5f104e&"
import script from "./registeraddresses.vue?vue&type=script&lang=js&"
export * from "./registeraddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports